import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import {
  FlexColumn,
  FlexRow,
  TableData,
  Text,
} from '@make-software/cspr-design';
import { AccountInfoAccordion } from '../account-info-accordion/account-info-accordion';
import { Table } from '@block-explorer/ui';
import DetailsTableRow from '../details-table-row/details-table-row';
import ExpandCollapsedButton from '../expand-collapsed/expand-collapsed-button';
import { useCustomHistory } from '../../router/navigation';
import { NFTTokenResult, PaginatedResponse } from '@block-explorer/entities';
import { NftTokenId } from '../deploy-actions/components/NftTokenIds';
import { buildRouterPath, useRouterPath } from '../../router/utils';
import { CONTRACT_PACKAGE_TAB_PATH, NFT_TOKEN_PATH } from '../../router/paths';
import { ContractIdentifier } from '../contract-identifier/contract-identifier';
import { HashFontSize } from '../table-data-account-info/table-data-account-info';
import DetailsValueTableData from '../details-value-table-data/details-value-table-data';
import styled from 'styled-components';

const MAXIMUM_VISIBLE_ROWS = 2;

const StyledDetailsValueTableData = styled(DetailsValueTableData)(
  ({ theme }) => ({
    '&&&': {
      padding: '16px 0',
    },
  })
);

const StyledTableFooterData = styled.td(({ theme }) => ({
  width: '100%',
  padding: '8px 0',
}));

export const DetailsAccordionContractNftsTokensFeed = ({
  nftTokens,
}: {
  nftTokens: PaginatedResponse<NFTTokenResult>;
}) => {
  const { t } = useTranslation();

  const history = useCustomHistory();
  const {
    urlParams: { id },
  } = useRouterPath(CONTRACT_PACKAGE_TAB_PATH);

  const handleExpandList = () => {
    history.push(
      buildRouterPath(
        CONTRACT_PACKAGE_TAB_PATH,
        { id, tab: 'assets' },
        undefined
      )
    );
  };

  return (
    <DetailsTableRow>
      <TableData>
        <AccountInfoAccordion
          withFeed
          disableClickAway
          renderContent={() => (
            <Table
              renderData={() => (
                <>
                  {nftTokens.data
                    ?.filter((item, i) => i < MAXIMUM_VISIBLE_ROWS)
                    .map((item) => {
                      return (
                        <DetailsTableRow key={item.token_id}>
                          <StyledDetailsValueTableData>
                            <FlexColumn gap={8}>
                              <ContractIdentifier
                                hash={item.contract_package_hash}
                                hashFontSize={HashFontSize.big}
                                contractPackage={item.contract_package}
                                hideContractType={false}
                                withName
                              />
                              <FlexRow>
                                <NftTokenId
                                  token_id={item.token_id}
                                  key={item.token_id}
                                  path={buildRouterPath(
                                    NFT_TOKEN_PATH,
                                    {
                                      contract_package_hash:
                                        item.contract_package_hash,
                                      token_id: item.token_id,
                                    },
                                    undefined
                                  )}
                                />
                              </FlexRow>
                            </FlexColumn>
                          </StyledDetailsValueTableData>
                        </DetailsTableRow>
                      );
                    })}
                  {nftTokens.data?.length > MAXIMUM_VISIBLE_ROWS && (
                    <DetailsTableRow key={'view-all-nfts'}>
                      <StyledTableFooterData>
                        <ExpandCollapsedButton
                          showArrow={false}
                          onExpand={handleExpandList}
                          collapsedLabel={<Trans t={t}>View all NFTs</Trans>}
                          hasTopMargin={false}
                        />
                      </StyledTableFooterData>
                    </DetailsTableRow>
                  )}
                </>
              )}
            />
          )}
        >
          <FlexRow gap={6}>
            <Trans t={t}>NFTs</Trans>{' '}
            <Text variation={'darkGray'}>&middot; {nftTokens.item_count}</Text>{' '}
          </FlexRow>
        </AccountInfoAccordion>
      </TableData>
    </DetailsTableRow>
  );
};
